<template>
    <v-tab
        class="tabs-navigation text-none"
        active-class="active"
        @click.prevent="selectNavigationItem(navigationItem)"
    >
        <v-img
            v-if="preview" 
            :src="preview"
            max-width="35"
            height="35"
            contain
            rounded
            class="white rounded-circle mr-2"
        />
        <v-icon
            v-else
            left
        >
            {{ `icon-${navigationItem.id}` }}
        </v-icon>
        <span>
            {{ navigationText }}
        </span>

        <template v-if="hasDropDownMenu">
            <NavigationItemMenu
                :navigationItem="navigationItem"
                :data="data"
                @selectNavigationItemMenu="selectNavigationItemMenu"
            />
        </template>
    </v-tab> 
</template>

<script>
    import NavigationItemMenu from '@/layout/alternative/layout/components/NavigationItemMenu.vue';

    export default {
        name: "NavigationItem",
        components:{
            NavigationItemMenu
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            navigationItem: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        computed: {
            preview() {
                return this.$props.navigationItem && this.$props.navigationItem.preview ? this.$props.navigationItem.preview : null;
            },
            hasDropDownMenu() {
                return this.$props.navigationItem && (this.$props.navigationItem.submenu || (this.$props.navigationItem.hotspots && this.$props.navigationItem.hotspots.length > 0));
            },
            navigationText() {
                return this.$props.navigationItem ? (this.$props.navigationItem.text ? this.$props.navigationItem.text : (this.$props.navigationItem.name ? this.$props.navigationItem.name : null)) : null;
            }
        },
        methods:{
            selectNavigationItem(item) {
                if (this.$props.data.type === 'documentation')
                    this.$emit('selectNavigationItem', this.$props.index);
                else
                    this.$emit('selectNavigationItem', item);
            },
            selectNavigationItemMenu(item, subItem) {
                this.$emit('selectNavigationItemMenu', item, subItem);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/layout/components/NavigationItem.vue